module.exports = __webpack_public_path__ + "static/media/MD website button_c_with text.ac2387c2.jpg";